import React from 'react'
import CustomersComp from '../../../components/Admin/customers'
import MasterLayoutAdmin from '../../../layout/Admin/masterLayoutAdmin'

export default function CostumersData() {
    return (
        <MasterLayoutAdmin>
            <CustomersComp />
        </MasterLayoutAdmin>
    )
}
